import React from 'react';
import clsx from 'clsx';
import Text from '@/components/ui/Text';
import useDuplicateImagesStore from './useDuplicateImagesStore';
import PrimaryImageIcon from './PrimaryImageIcon';

interface ImageHeaderCellProps {
  imageSrc: string;
  label: 'Duplicate Image' | 'Uploaded Image';
  isDuplicate?: boolean;
  imageId: number;
}

const ImageHeaderCell = ({ imageSrc, label, isDuplicate = false, imageId }: ImageHeaderCellProps) => {
  const isPrimaryImage = useDuplicateImagesStore(state => state.isPrimaryImage);
  const isImageChecked = useDuplicateImagesStore(state => state.isImageChecked);
  const toggleImageChecked = useDuplicateImagesStore(state => state.toggleImageChecked);

  const handleImageCheck = () => {
    if (!isDuplicate) return;
    toggleImageChecked(imageId);
  };

  return (
    <label
      className={clsx('tw-flex tw-flex-col tw-items-center tw-p-2', {
        'tw-text-green': !isDuplicate,
        'tw-text-tci-purple': isDuplicate && isPrimaryImage(imageId),
      })}
      htmlFor={`header-${imageId}`}
    >
      <div className="tw-relative tw-w-full">
        {isPrimaryImage(imageId) && (
          <div
            className={clsx(
              'tw-absolute -tw-top-1 -tw-left-1 tw-w-16 tw-h-5',
              'tw-flex tw-items-center tw-justify-center tw-bg-tci-purple tw-rounded-md',
            )}
          >
            <PrimaryImageIcon />
            <span className="tw-text-white tw-text-[10px] tw-font-normal tw-pr-1">
              Primary
            </span>
          </div>
        )}
        <img
          alt={label}
          className="tw-w-full tw-height-full tw-object-contain tw-rounded tw-border tw-border-solid"
          src={imageSrc}
        />
        <input
          aria-label={`Include ${label} in merge (Image ID: ${imageId})`}
          checked={isImageChecked(imageId)}
          className="tw-absolute tw-top-1 tw-right-1 tw-w-4 tw-h-4"
          id={`header-${imageId}`}
          tabIndex={0}
          type="checkbox"
          onChange={handleImageCheck}
          onKeyDown={(event: React.KeyboardEvent) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              handleImageCheck();
            }
          }}
        />
      </div>
      <Text
        className="tw-self-start"
        size="sm"
        weight="normal"
      >
        {label}
      </Text>
    </label>
  );
};

export default ImageHeaderCell;
